// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11.7 4.95H12.5C13.33 4.95 14 5.62 14 6.45V13C14 13.55 13.55 14 13 14H11.7M11.7 4.95V4C11.7 2.9 10.8 2 9.7 2H4C2.9 2 2 2.9 2 4V13C2 13.55 2.45 14 3 14H5.45M11.7 4.95V14M5.45 14H8.25L11.7 14M4.85 10.91H5.45M5.45 10.91V14M5.45 10.91H8.25M8.25 10.91H8.85M8.25 10.91V14',
  'M4.41 8.07H4.42M6.83 8.07H6.84M9.27 8.06H9.28M4.39 4.95H4.4M6.84 4.95H6.85M9.27 4.95H9.28',
];
